import { ThunderDispatcher } from '../thunder-dispatcher.js';
export var SyncStatus;
(function (SyncStatus) {
    SyncStatus[SyncStatus["loading"] = 0] = "loading";
    SyncStatus[SyncStatus["idle"] = 1] = "idle";
    SyncStatus[SyncStatus["read"] = 2] = "read";
    SyncStatus[SyncStatus["write"] = 3] = "write";
})(SyncStatus || (SyncStatus = {}));
export var DataStatus;
(function (DataStatus) {
    DataStatus[DataStatus["NoData"] = 0] = "NoData";
    DataStatus[DataStatus["UpdatingData"] = 1] = "UpdatingData";
    DataStatus[DataStatus["ContainsData"] = 2] = "ContainsData";
    // UpdatingDelta, //render
    // UpToDate//render
})(DataStatus || (DataStatus = {}));
export const syncDispatcher = new ThunderDispatcher('__onSyncStatusChanged');
export const EventType_UpsertAll = 'upsert-all';
export const EventType_Create = 'create';
export const EventType_Update = 'update';
export const EventType_Patch = 'patch';
export const EventType_Unique = 'unique';
export const EventType_Query = 'query';
export const EventType_Delete = 'delete';
export const EventType_DeleteMulti = 'delete-multi';
//# sourceMappingURL=consts.js.map